module.exports = __webpack_public_path__ + "media/video_login.1c161603.mp4";